import React, { Component } from 'react';
import classes from "./ReportsPageTabs.module.css";
import ProgressBar from "../UI/ProgressBar/ProgressBar";
import GradeTable from '../GradeTable/GradeTable';
import ResourceAPIController from '../../webServices/ResourceAPIController';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';
import SortHelper from '../../utilities/SortHelper';
import * as actionCreators from '../../store/actions/index';
import { connect } from "react-redux";

class ClassGrades extends Component {
    state = {
        reportData: {
            passedStudents: 0,
            totalStudents: 0,
            classGrade: 0,
        },
        gradesList: [
            {
                name: "",
                overallGrade: '-',
                grades: []
            }
        ],
        fullGradesList: [
            {
                name: "",
                overallGrade: '-',
                grades: []
            }
        ],
        columnData: [],
        showLoader: true,
        showNameFilterDropdown: false,
        nameFilterItems: [{ id: 1, label: 'A -> Z' }, { id: 2, label: 'Z -> A' }],
        showGradesFilterDropdown: false,
        gradesFilterItems: [{ id: 1, label: 'Highest' }, { id: 2, label: 'Lowest' }],
        activeNameFilterDropDownItem: -1,
        activeGradesFilterDropDownItem: -1,
        nameSearchFieldValue: '',
        isProgramManager: this.props.isProgramManager,
    }

    onViewAllClicked = (e) => {
        const status = this.state.viewAll;
        if (status === false) {
            this.setState({ viewAll: !status, showLoader: true, activeNameFilterDropDownItem: -1, activeGradesFilterDropDownItem: -1, gradesList: [], nameSearchFieldValue: '' });
            this.state.isProgramManager !== true && this.props.hideReportsNavigation(status, 'ClassGrades');
            this.getInstructorClassGradesReport(!status);
            this.state.isProgramManager && this.props.handleSideBar(status);
        } else {
            const updatedList = [...this.state.fullGradesList];
            this.setState({ viewAll: !status, showLoader: true, activeNameFilterDropDownItem: -1, activeGradesFilterDropDownItem: -1, gradesList: updatedList, nameSearchFieldValue: '' });
            this.state.isProgramManager && this.props.handleSideBar(status);
            this.getInstructorClassGradesReport(!status);
            this.state.isProgramManager !== true && this.props.hideReportsNavigation(status, 'ClassGrades');
        }
    }

    onNameFilterClicked = () => {
        let updatedState = this.state.showNameFilterDropdown;
        this.setState({ showNameFilterDropdown: !updatedState, showGradesFilterDropdown: false });
    }

    onGradesFilterClicked = () => {
        let updatedState = this.state.showGradesFilterDropdown;
        this.setState({ showGradesFilterDropdown: !updatedState, showNameFilterDropdown: false });
    }

    onDropDownItemClicked = (pos, isGrades) => {
        // alert(pos + ' something ' + isGrades);
        let updatedList = [...this.state.gradesList];

        if (isGrades !== true) {
            // -------- Sort by Name --------
            if (pos === 0) {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'ascending');
            } else {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'descending');
            }
            this.setState({
                gradesList: updatedList,
                activeNameFilterDropDownItem: pos,
                activeGradesFilterDropDownItem: -1,
                showNameFilterDropdown: false
            })
        } else {
            // -------- Sort by Grades --------
            if (pos === 0) {
                updatedList = updatedList.sort((a, b) => (b.overallGrade - a.overallGrade));
            } else {
                updatedList = updatedList.sort((a, b) => (a.overallGrade - b.overallGrade));
            }
            this.setState({
                gradesList: updatedList,
                activeGradesFilterDropDownItem: pos,
                activeNameFilterDropDownItem: -1,
                showGradesFilterDropdown: false
            });
        }
    }

    nameSearchInputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ nameSearchFieldValue: updatedValue });
    }

    onNameSearchIconClick = (searchString) => {
        const updatedSearchString = searchString.toLowerCase();
        const newList = this.state.fullGradesList.filter(student => {
            if (student.name.toLowerCase().indexOf(updatedSearchString) !== -1) {
                return true;
            }
        });

        if (!IsListEmpty(newList)) {
            this.setState({ gradesList: newList, showNameFilterDropdown: false, nameSearchFieldValue: searchString, activeNameFilterDropDownItem: -1, activeRatingFilterDropDownItem: -1 });
        } else {
            this.props.onFailureDialogShow('No student found with the matching name.', 'OKAY');
        }

    }

    clearSearchResults = () => {
        const updatedList = [...this.state.fullGradesList];
        this.setState({ gradesList: updatedList, activeNameFilterDropDownItem: -1, showNameFilterDropdown: false, nameSearchFieldValue: '' });
    }

    getInstructorClassGradesReport = (full) => {

        ResourceAPIController.getInstructorClassGradesReport(this.props.batchCode, this.props.moduleName, full)
            .then(response => {

                // console.log('getInstructorClassGradesReport Data => ', response.result);

                this.setState({
                    showLoader: false,
                    reportData: response.result.reportData,
                    gradesList: response.result.gradesList,
                    fullGradesList: response.result.gradesList,
                    columnData: response.result.columnData,
                });

            })
            .catch(err => {
                console.log('getInstructorClassGradesReport error => ', err)
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }


    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getInstructorClassGradesReport(batchCode, moduleName, this.state.viewAll);
        }
        if (this.props.isProgramManager !== true) {
            this.props.setupProgramDetailsTopbar(true, false, false, false);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getInstructorClassGradesReport(batchCode, moduleName, this.state.viewAll);
        }
    }

    render() {
        return (
            <>
                <div className={this.state.viewAll ? classes.ReportsPageHeadingFull : classes.ReportsPageHeading}>
                    {this.props.isProgramManager ? "Class Grades" : "Class Grades Report"}
                </div>
                {
                    this.state.showLoader
                        ? <div className={classes.LoaderContainer}><ShowLoader isLoading={true} /></div>
                        : <div className={classes.GradesPageContainer}>

                            {this.state.viewAll ? null
                                : <>
                                    <div className={classes.ReportsCard}>
                                        <div className={classes.GradesCardContainer}>
                                            <div className={classes.ProgressCard}>
                                                <p className={classes.ProgressStat}>{this.state.reportData.passedStudents}
                                                    <span className={classes.PercentageText}> /{this.state.reportData.totalStudents}</span>
                                                </p>
                                                <p className={classes.ProgressText}>Passed</p>
                                            </div>
                                            <div className={classes.ProgressCard}>
                                                <p className={classes.ProgressStat}>{this.state.reportData.classGrade} %</p>
                                                <p className={classes.ProgressText}>Class Grade</p>
                                                <div className={classes.ProgressBarDiv}>
                                                    <ProgressBar
                                                        styleclass={this.state.reportData.classGrade >= 80 ? "Green"
                                                            : this.state.reportData.classGrade >= 70 ? "Yellow" : "Red"}
                                                        showProgressText={false}
                                                        progress={this.state.reportData.classGrade} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                !IsListEmpty(this.state.columnData)
                                    ? <div className={this.state.viewAll ? classes.LinkTextContainerFull : classes.LinkTextContainer}>
                                        {/* <div className={classes.LinkText}>Download Report</div> */}
                                        <div className={classes.LinkText}
                                            onClick={(e) => this.onViewAllClicked()}>
                                            {this.state.viewAll ? "BACK TO OVERVIEW" : "VIEW ALL"}
                                        </div>
                                    </div>
                                    : null
                            }

                            <GradeTable
                                data={this.state.gradesList}
                                columnData={this.state.columnData}
                                tableHead1={"Name"}
                                tableHead2={"Overall Grade"}
                                colHead1={"Class Average Score"}
                                colHead2={this.state.reportData.classGrade}
                                viewAll={this.state.viewAll}

                                onNameFilterClicked={this.onNameFilterClicked}
                                onAttendanceFilterClicked={this.onGradesFilterClicked}
                                showNameFilterDropdown={this.state.showNameFilterDropdown}
                                showAttendanceFilterDropdown={this.state.showGradesFilterDropdown}
                                nameDropDownItems={this.state.nameFilterItems}
                                attendanceDropDownItems={this.state.gradesFilterItems}
                                onDropDownClicked={this.onNameFilterClicked}
                                onDropDownItemClicked={this.onDropDownItemClicked}
                                activeNameDropdownItem={this.state.activeNameFilterDropDownItem}
                                activeAttendanceDropdownItem={this.state.activeGradesFilterDropDownItem}
                                nameSearchFieldValue={this.state.nameSearchFieldValue}
                                nameSearchInputChangeHandler={this.nameSearchInputChangeHandler}
                                onNameSearchIconClick={this.onNameSearchIconClick}
                                clearSearchResults={this.clearSearchResults}
                                searchString={this.state.nameSearchFieldValue}
                            />

                        </div>
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        activeModuleId: state.activeModuleId,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(ClassGrades);
